import { ArticleJsonLd, BreadcrumbJsonLd, CarouselJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import {
  toAbsoluteLink,
  toArticleCategoryLink,
  toArticleLink,
  toOfferLink,
} from 'lib/links';
import placeholder from 'lib/placeholder';
import { toFormattedJsonLdString } from 'lib/string';

import APP from 'constants/app';

const Schema = ({
  articleImage,
  articleSlug,
  articleDescription,
  articleTitle,
  articleModifiedDate,
  articlePublished,
  categoryName,
  categorySlug,
  userName,
  relatedOffers,
}) => (
  <>
    <BreadcrumbJsonLd
      itemListElements={[
        {
          position: 1,
          name: placeholder('breadcrumbs.app'),
          item: APP.URL,
        },
        {
          position: 2,
          name: categoryName,
          item: toArticleCategoryLink(categorySlug),
        },
        {
          position: 3,
          name: toFormattedJsonLdString(articleTitle),
          item: toAbsoluteLink(toArticleLink(articleSlug)),
        },
      ]}
    />
    <ArticleJsonLd
      authorName={userName}
      dateModified={articleModifiedDate}
      datePublished={articlePublished}
      description={toFormattedJsonLdString(articleDescription)}
      images={[articleImage]}
      publisherLogo={toAbsoluteLink(
        `${APP.LOCAL_IMAGE_PATH}/features/topbar/promobit-logo.svg`
      )}
      publisherName={userName}
      title={toFormattedJsonLdString(articleTitle)}
      url={toAbsoluteLink(toArticleLink(articleSlug))}
    />
    {relatedOffers?.length > 0 && (
      <CarouselJsonLd
        data={relatedOffers.map(({ offerSlug }) => ({
          url: toAbsoluteLink(toOfferLink(offerSlug)),
        }))}
        ofType="default"
      />
    )}
  </>
);

Schema.propTypes = {
  articleDescription: PropTypes.string.isRequired,
  articleImage: PropTypes.string.isRequired,
  articleSlug: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  articleModifiedDate: PropTypes.string.isRequired,
  articlePublished: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  categorySlug: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};

export default Schema;
